import { Component, Input, OnInit } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { AggFunc, BaseComponent, FormatService, FormlyService, GridService } from 'tms-lib';
import { CreditCheck, CreditCheckDetails } from '../../../models';

@Component({
  selector: 'app-customer-credit-check',
  templateUrl: './customer-credit-check.component.html',
  styleUrl: './customer-credit-check.component.scss',
})
export class CustomerCreditCheckComponent extends BaseComponent implements OnInit {
  @Input() creditCheck: CreditCheck;
  @Input() creditCheckDetails: CreditCheckDetails[];
  @Input() header: string;
  @Input() customerId: string;

  fields: FormlyFieldConfig[];

  columnDefs: ColDef[] = [
    this.gridService.text('type', $localize`Type`),
    this.gridService.text('reference', $localize`Reference`),
    this.gridService.text('additionalReference', $localize`Additional Reference`),
    this.gridService.date('date', $localize`Date`),
    this.gridService.numberFormat('goodsAmount', $localize`Nett`, { aggFunc: AggFunc.sum }),
    this.gridService.numberFormat('taxAmount', $localize`Tax`, { aggFunc: AggFunc.sum }),
    this.gridService.numberFormat('totalAmount', $localize`Total`, { aggFunc: AggFunc.sum }),
    this.gridService.numberFormat('totalPaid', $localize`Amount Paid`, { aggFunc: AggFunc.sum }),
    this.gridService.numberFormat('outstandingAmount', $localize`Outstanding`, { aggFunc: AggFunc.sum }),
    this.gridService.date('dueDate', $localize`Due Date`),
    this.gridService.date('datePaid', $localize`Date Paid`),
    this.gridService.numberFormat('daysLate', $localize`Days Late`, undefined, true, 0),
    this.gridService.text('status', $localize`Status`),
    this.gridService.text('overdueStatus', $localize`Overdue Status`),
  ];

  constructor(
    private gridService: GridService,
    private formatService: FormatService,
    private formlyService: FormlyService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getFields();
  }

  private getFields() {
    this.fields = [
      ...this.formlyService.threeColumnGrid(
        [
          this.formlyService.text('key', $localize`Customer`, undefined, { readonly: true }),
          this.formlyService.text('paymentTerms', $localize`Payment Terms`, undefined, { readonly: true }),
          this.formlyService.text('onStopString', $localize`On Stop`, undefined, { readonly: true }),
          this.formlyService.text('creditLimit', $localize`Credit Limit`, undefined, {
            readonly: true,
            textRight: true,
          }),
          this.formlyService.text('totalXero', $localize`Total Accounts`, undefined, {
            readonly: true,
            textRight: true,
          }),
          this.formlyService.text('totalOutstandingOrder', $localize`Outstanding Order`, undefined, {
            readonly: true,
            textRight: true,
          }),
          this.formlyService.text('balance', $localize`Balance`, undefined, { readonly: true, textRight: true }),
        ],
        [
          this.formlyService.text('name', $localize`Name`, undefined, { readonly: true }),
          this.formlyService.textAreaReadonly('address', $localize`Address`, undefined, { rows: 8 }),
        ],
        [],
      ),
    ];
  }
}
